import { useEffect, useRef, useState } from "react";
import { Music, VolumeX } from "lucide-react";
import { toast } from "sonner";
import { siteConfig } from "../config/siteConfig";

export default function MusicToggle() {
  const { music } = siteConfig;
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = music.volume ?? 0.25;
      audioRef.current.loop = true;
    }
  }, [music.volume]);

  const toggle = async () => {
    if (!music.src) {
      toast.info("Music URL not configured.");
      return;
    }
    const a = audioRef.current;
    if (!a) return;
    try {
      if (playing) {
        a.pause();
        setPlaying(false);
      } else {
        await a.play();
        setPlaying(true);
      }
    } catch (err) {
      console.error("Music playback error:", err);
      toast.error("Could not play audio. Try again after interacting with the page.");
    }
  };

  return (
    <>
      {music.src && (
        <audio
          ref={audioRef}
          src={music.src}
          preload="none"
          data-testid="bg-music-audio"
        />
      )}
      <button
        onClick={toggle}
        aria-label={playing ? "Pause music" : "Play calm music"}
        data-testid="music-toggle"
        className="fixed bottom-6 left-6 z-40 w-12 h-12 rounded-full bg-[#1A362D] text-[#C5A059] border border-[#C5A059]/40 flex items-center justify-center shadow-xl hover:bg-[#C5A059] hover:text-[#1A362D] transition-colors"
        title={playing ? "Pause ambient music" : "Play ambient music"}
      >
        {playing ? (
          <Music className="w-5 h-5" strokeWidth={1.5} />
        ) : (
          <VolumeX className="w-5 h-5" strokeWidth={1.5} />
        )}
      </button>
    </>
  );
}
